import * as React from "react";
import { Button, Popover } from "./externals";
import { Loading } from "./Loading";
const ChromePicker = React.lazy(() => import("react-color").then((module) => ({
    default: module.ChromePicker,
})));
export class ColorPicker extends React.PureComponent {
    render() {
        const { color } = this.props;
        return (React.createElement(Popover, { usePortal: false },
            React.createElement(Button, { text: React.createElement("div", { style: { width: "100px", height: "20px", backgroundColor: color } }) }),
            React.createElement(React.Suspense, { fallback: React.createElement(Loading, null) },
                React.createElement(ChromePicker, { color: this.props.color, disableAlpha: true, onChange: this.props.onChange }))));
    }
}
//# sourceMappingURL=ColorPicker.js.map